// Import React, styles, SVG icons, and navigation hook
import React from "react";
import "../../css/components/Footer.css";
import { ReactComponent as LinkedInIcon } from "../../assets/icons/LinkedIn.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/Contact.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/Email.svg";
import { useNavigate } from "react-router-dom";

/**
 * Footer component displays contact info, social links, and legal disclaimers.
 */
function Footer() {
  // useNavigate hook for client-side navigation
  const navigate = useNavigate();
  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-Content">
          {/* Contact section with email and phone */}
          <div className="footer-contact">
            <div className="contact-item">
              <span className="icon">
                <EmailIcon />
              </span>
              <span>
                <a
                  href="mailto:enquiries@fgwealthadvisory.co.uk"
                  className="primary"
                >
                  enquiries@fgwealthadvisory.co.uk
                </a>
              </span>
            </div>
            <div className="contact-item">
              <span className="icon">
                <PhoneIcon />
              </span>
              <span>
                <a href="tel:07759727170" className="primary">
                  033 3366 0988
                </a>
              </span>
            </div>
          </div>
          {/* Social media links */}
          <div className="footer-social">
            {/* <a
              href="https://www.instagram.com/avarosemortgages/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon facebook"
              aria-label="Instagram"
            >
              <InstaIcon />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61580737965094"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon facebook"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a> */}

            <a
              href="https://www.linkedin.com/company/fgwealthadvisory/"
              className="social-icon linkedin"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>
        </div>
      </div>
      {/* Legal disclaimer and privacy policy link */}
      <div className="footer-disclaimer">
        {/* <h2
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => navigate("/privacy-policy")}
        >
          Privacy Policy
        </h2> */}
        <div className="help-text ">
          If you wish to register a complaint, please write to Complaints
          Officer, Rosemount Financial Solutions IFA Ltd, Rosemount House, 2-4
          Chequers Road, Basingstoke, RG21 7PU.  Telephone 01256 405460 or email
          complaints complaints@rosemountfsIFA.co.uk. A summary of our internal
          complaints handling procedures for the reasonable and prompt handling
          of complaints is available on request and if you cannot settle your
          complaint with us, you may be entitled to refer it to the Financial
          Ombudsman Service at: https://www.financial-ombudsman.org.uk/ or by
          contacting them on 0800 023 4567.
          {/*
            <a
              href="https://register.fca.org.uk/s/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
              (https://register.fca.org.uk/s/)
            </a>
            under reference 535515. Rosemount Financial Solutions (IFA) Ltd is
            authorised and regulated by the Financial Conduct Authority.
          */}
        </div>

        <div className="help-text">
          FG Wealth Advisory is a trading style of Columbus Fifty Six Limited
          which is Appointed Rosemount Financial Solutions (IFA) Ltd which is
          authorised and regulated by the Financial Conduct Authority (FCA). 
          Entered on the FCA Register (https://register.fca.org.uk/) under
          reference 535515. Registered as a Limited Company in England & Wales
          No 11678977. Registered Address: Suite 19, Commer House, Station Road,
          Tadcaster, England, LS24 9JF
        </div>
        <div
          className="button-text"
          onClick={() => navigate("/privacy-policy")}
          style={{ cursor: "pointer" }}
        >
          Read the Privacy Policy here
        </div>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
